import { useState, useCallback } from "react"
import { useHistory } from "react-router-dom"
import apiClient from "../helpers/apiClient"
import { useToast } from "../context/ToastContext";
import { AUTH_API_USER_TYPE } from "../services/auth.service"
import { getApiErrorMessage } from "../helpers/getApiErrorMessage"


export default function useSignup(initialType = "resto") {
    const api = apiClient();
    const h = useHistory();
    const toast = useToast()
    const [name, setName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [resto, setResto] = useState(null)
    const [successAcount, setSuccessAccount] = useState(false)
    const [pendingApproval, setPendingApproval] = useState(false)
    const [type, setType] = useState(initialType)
    const [loading, setLoading] = useState(false)

    const register = useCallback((options = {}) => {
        const { onRestoNotFound } = options;

        if (!name || name.trim() === "") {
            toast.error("Por favor, ingresa tu nombre.")
            return
        }
        if (!lastName || lastName.trim() === "") {
            toast.error("Por favor, ingresa tu apellido.")
            return
        }
        if (!email || email.trim() === "") {
            toast.error("Por favor, ingresa tu correo electrónico.")
            return
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
            toast.error("Por favor, ingresa un correo electrónico válido.")
            return
        }

        if (!resto || typeof resto !== "object" || !resto.name || !resto.place_id) {
            toast.error("Por favor, selecciona tu restaurante.")
            return
        }

        setLoading(true)
        setPendingApproval(false)
        api.post(`/api/v2/auth/signup`, { name, lastName, email, resto, type: AUTH_API_USER_TYPE })
            .then((response) => {
                const hasLogicalError = response?.error === true
                const responseMessage = response?.message || ""
                const restoNoExistePattern = /(restaur|no encontrado|not found|does not exist|inexistente)/i

                if (hasLogicalError) {
                    if (type === "host" && restoNoExistePattern.test(responseMessage)) {
                        onRestoNotFound?.({
                            resto: response?.resto || resto,
                            hostName: response?.hostName || name,
                            hostLastName: response?.hostLastName || lastName,
                            errorMessage: responseMessage,
                        })
                        return
                    }

                    toast.error(responseMessage || "Se ha producido un error inesperado. Inténtelo de nuevo más tarde")
                    return
                }

                const isPendingApproval = type === "resto" && response?.resto?.approvalStatus === "pending"
                setPendingApproval(isPendingApproval)
                setSuccessAccount(true)
            })
            .catch((error) => {
                const errorMessage = getApiErrorMessage(error, "")
                const restoNoExistePattern = /(restaur|no encontrado|not found|does not exist|inexistente)/i

                if (type === "host" && restoNoExistePattern.test(errorMessage)) {
                    onRestoNotFound?.({ resto, errorMessage })
                    return
                }

                toast.error(errorMessage || "Se ha producido un error inesperado. Inténtelo de nuevo más tarde")
            })
            .finally(() => setLoading(false))
    }, [name, lastName, email, resto, type])

    const goToLogin = useCallback(() => { h.push("/login") }, [])

    return {
        name,
        setName,
        lastName,
        setLastName,
        email,
        setEmail,
        resto,
        setResto,
        register,
        successAcount,
        goToLogin,
        setType,
        type,
        loading,
        pendingApproval,
    }
}
